export enum FilestackStatus {
  None = 0,
  Processing = 1,
  Ready = 2
}
